import React from 'react'
import { withIcon } from '../../withIcon'

function StarSolidIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path d="M12.007 18.2515L5.835 21.4965L7.014 14.6235L2.014 9.75651L8.91399 8.75651L12 2.50351L15.086 8.75651L21.986 9.75651L16.986 14.6235L18.165 21.4965L12.007 18.2515Z" fill={color}/>
    </svg>
  )
}

export default withIcon(StarSolidIcon)
